import {Injectable} from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';
import {Observable} from 'rxjs/Rx';
import {Client} from '../../models/client';

@Injectable()
export class NeoClientService {

    constructor(
        private _rest: NeoRestService
    ) {
    }

    /**
     * Obtiene la lista de clientes
     */
    getClients(): Observable<any> {
        return this._rest.get(`/client`);
    }


    /**
     * Obtiene un cliente
     *
     * @param id
     */
    getClient(id: string): Observable<any> {
        return this._rest.get(`/client/${id}`);
    }

    /**
     * Crea un cliente
     *
     * @returns {Observable<any>}
     * @param client
     */
    createClient(client: Client) {
        return this._rest.postRaw('/client', client);
    }

    /**
     * Actualiza los datos de un cliente
     *
     * @param id
     * @param values
     * @returns {Observable<any>}
     */
    updateClient(id, values) {
        return this._rest.putRaw(`/client/${id}`, values);
    }

    /**
     * Elimina un cliente
     *
     * @param id Id del usuario
     * @returns {Observable<any>}
     */
    deleteClient(id: string) {
        return this._rest.delete(`/client/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-client/neo-client.service.ts